class MouseEventManager {
    add_mouse_event(obj) {
        // console.error("add_mouse_event", obj);
        obj.target.mouseChildren = false;
        obj.target.removeAllEventListeners();
        obj.target.gotoAndStop(0);
        //obj.itemControl.loader.singleAntialiasing(obj.target);
        obj.target.addEventListener("click", () => {
            //window.currentPageItemControl = obj.itemControl;
            // console.log('trigger', e);
            obj.trigger();
        });
        obj.target.addEventListener("mouseover", () => {
            //console.log("AAA")
            if (obj.target.currentFrame == 1) return;
            obj.target.gotoAndStop(1);
            // console.log('mouseover', obj);
            obj.itemControl.loader.singleAntialiasing(obj.target);
        });
        obj.target.addEventListener("mouseout", () => {
            obj.target.gotoAndStop(0);
            obj.itemControl.loader.singleAntialiasing(obj.target);
        });

        // obj.target.timeline.removeTween(obj.target.timeline.tweens[0]);

    }
}



export var mouseEvent = new MouseEventManager();